<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'BookingMain'
}
</script>